<app-header *ngIf="!contVisible"></app-header>
<main role="main" class="maincnt mainmrg precontactbckimg">
  <div class="getbannersect sectppad pb-2 mt-1">
    <div class="sectpad container-fluid">
      <div class="col-sm-12 p-0">
        <div class="col-sm-12 p-0 margntp">
          <div class="col-sm-12 p-0 text-center">
            <div class="m-auto col-sm-10 col-md-6 col-xl-4">
              <img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569487792/Static%20images/Faq/precontacthi_zjijcl.svg" class="mb-1 col-6 col-sm-5 col-md-6 col-lg-6 col-xl-6 cnthiimg" alt="Illustration of the word Hi in pink" title="Hi illustration" />
            </div>
            <h1 class="text-center success mt-2 precontacthead semi-bold">{{header}}</h1>
            <p class="text-center precontacttext font-weight-normal-calibre">Contact Us 7 days a week for advice on everything
              from your billing to your
              energy choice</p>
            <a class="btn mr-2 sectbtn col-5 col-sm-3 col-md-3 col-lg-2 col-xl-2 mt-4 text-uppercase precontactbtn font-weight-bold-calibre"
            href="javascript:void(0)"
              data-toggle="modal" data-target="#contactModal" (click)="showModal()">GET HELP</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
<app-footer *ngIf="!contVisible"></app-footer>
<app-contactus [mVisible]="modalVisible" (closeModalEvent)="onClose($event)"></app-contactus>